import { QueryConfig, QueryResult } from './types/dataQuery';
import { useQueryV5 } from './adapters/useQueryV5';
import { QueryFunction, QueryKey } from './types';

export function useDataQuery<TResult = unknown, TError = unknown>(
	queryKey: QueryKey,
	queryFn: QueryFunction<TResult>,
	queryConfig?: QueryConfig<TResult, TError>,
): QueryResult<TResult, TError>;

export function useDataQuery(queryKey, queryFn, queryConfig) {
	return useQueryV5(queryKey, queryFn, queryConfig);
}
